import React, { PropsWithChildren, ReactElement, ReactNode } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FORM_DIRECTION_TYPE, FormDirectionType, Hint as _Hint } from '@bucketplace/commerce-admin-ui';
import { FONT_STYLE } from '@bucketplace/design-system';

type FieldWidth = string | number;
type HintAlign = 'start' | 'end';
export interface FieldItemProps {
  label?: ReactNode;
  hint?: string;
  error?: boolean;
  width?: FieldWidth;
  direction?: FormDirectionType;
  hintAlign?: HintAlign;
}

export function FieldItem({
  label,
  hint,
  error,
  width,
  direction = FORM_DIRECTION_TYPE.VERTICAL,
  children,
  hintAlign = 'start',
}: PropsWithChildren<FieldItemProps>): ReactElement {
  return (
    <Container direction={direction}>
      {
        !!label && (
          <Label direction={direction}>{ label }</Label>
        )
      }
      <Content data-testid="field-item-content" width={width}>
        { children }
        { hint && (
          <Hint error={error} hintAlign={hintAlign}>
            { hint }
          </Hint>
        ) }
      </Content>
    </Container>
  );
}

const Container = styled.div<{ direction: FormDirectionType }>`
  ${({ direction }) => direction === FORM_DIRECTION_TYPE.HORIZONTAL && css`
    display: flex;
    align-items: center;
  `}
`;

const Label = styled.span<{ direction: FormDirectionType }>`
  display: inline-block;
  font-weight: 500;
  ${FONT_STYLE.body14L18};
  ${({ direction }) => direction === FORM_DIRECTION_TYPE.HORIZONTAL
    ? css`
      margin-right: 12px;
    `
    : css`
      margin-bottom: 12px;
    `};
`;

const Content = styled.div<{ width?: FieldWidth }>`
  display: flex;
  flex-direction: column;
  ${({ width }) => width && css`
    width: ${typeof width === 'number' ? `${width}px` : width}
  `}
`;

const Hint = styled(_Hint)<{ hintAlign: HintAlign }>`
  justify-content: ${({ hintAlign }) => hintAlign};
`;
